import * as React from 'react';
import { ContractEditorScreen, type EditorTabId } from '../components/contracts.js';

/**
 * `/smlouvy/:id` — EDITOR jedne smlouvy (krok UXS1 bod 1 a 3).
 *
 * Do ted editor nemel adresu: „Otevřít" v prehledu jen prepnulo vnitrni stav,
 * takze Zpet v prohlizeci odesel ze smluv a odkaz na konkretni smlouvu
 * neexistoval (nalez R.B. 1. 10., bod 2). `?zalozka=podpis|klient` otevre
 * rovnou prislusnou zalozku smlouvy.
 */
export function SmlouvaDetailPage({
  contractId,
  tab,
}: {
  readonly contractId: string;
  readonly tab?: EditorTabId | undefined;
}): React.JSX.Element {
  return (
    // Krok SML2 bod 1: editor jde od hrany k hrane (rezim soustredeni).
    // Odsazeni si kresli hlavicka editoru, ne stranka.
    <div data-testid="smlouva-detail-page">
      <ContractEditorScreen contractId={contractId} {...(tab !== undefined ? { initialTab: tab } : {})} />
    </div>
  );
}
